import { createSlice } from '@reduxjs/toolkit';

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        // Organization dashboard
        data: {},
        loading: false,
        error: null,
        
        // Project dashboard
        projectDashboard: {},
        projectDashboardLoading: false,
        projectDashboardError: null,
        
        // Roadmap dashboard
        roadmapDashboard: {},
        roadmapDashboardLoading: false,
        roadmapDashboardError: null,
        
        // Roadmap group dashboard
        roadmapGroupDashboard: {},
        roadmapGroupDashboardLoading: false,
        roadmapGroupDashboardError: null,

        // Refresh status
        refreshStatus: {},
        refreshStatusLoading: false,
        refreshStatusError: null,
    },
    reducers: {
        // Organization dashboard
        setDashboardData: (state, action) => {
            state.data = action.payload;
        },
        setDashboardLoading: (state, action) => {
            state.loading = action.payload;
        },
        setDashboardError: (state, action) => {
            state.error = action.payload;
        },
        
        // Project dashboard
        setProjectDashboardData: (state, action) => {
            state.projectDashboard = action.payload;
        },
        setProjectDashboardLoading: (state, action) => {
            state.projectDashboardLoading = action.payload;
        },
        setProjectDashboardError: (state, action) => {
            state.projectDashboardError = action.payload;
        },
        
        // Roadmap dashboard
        setRoadmapDashboardData: (state, action) => {
            state.roadmapDashboard = action.payload;
        },
        setRoadmapDashboardLoading: (state, action) => {
            state.roadmapDashboardLoading = action.payload;
        },
        setRoadmapDashboardError: (state, action) => {
            state.roadmapDashboardError = action.payload;
        },
        
        // Roadmap group dashboard
        setRoadmapGroupDashboardData: (state, action) => {
            state.roadmapGroupDashboard = action.payload;
        },
        setRoadmapGroupDashboardLoading: (state, action) => {
            state.roadmapGroupDashboardLoading = action.payload;
        },
        setRoadmapGroupDashboardError: (state, action) => {
            state.roadmapGroupDashboardError = action.payload;
        },

        // Refresh status
        setRefreshStatus: (state, action) => {
            state.refreshStatus = action.payload;
        },
        setRefreshStatusLoading: (state, action) => {
            state.refreshStatusLoading = action.payload;
        },
        setRefreshStatusError: (state, action) => {
            state.refreshStatusError = action.payload;
        },
    }
});

export const {
    setDashboardData,
    setDashboardLoading,
    setDashboardError,
    setProjectDashboardData,
    setProjectDashboardLoading,
    setProjectDashboardError,
    setRoadmapDashboardData,
    setRoadmapDashboardLoading,
    setRoadmapDashboardError,
    setRoadmapGroupDashboardData,
    setRoadmapGroupDashboardLoading,
    setRoadmapGroupDashboardError,
    setRefreshStatus,
    setRefreshStatusLoading,
    setRefreshStatusError
} = dashboardSlice.actions;

export default dashboardSlice.reducer; 